/* eslint-disable no-unused-vars */
// eslint-disable-next-line no-shadow
export enum QueryTypes {
  GET = 'get',
  POST = 'post',
  POST_FEEDBACK = 'post',
  PUT = 'put',
}
